import * as yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { noSpaces, emailRegex } from '../../utils/regexs';

export interface CheckoutFormData {
  contactMethod: 'phone' | 'email';
  email?: string;
  emailConfirm?: string;
  phone?: string;
  phoneConfirm?: string;
}

export const checkoutValidationSchema = yup.object<CheckoutFormData>().shape({
  contactMethod: yup
    .mixed<'phone' | 'email'>()
    .oneOf(['phone', 'email'])
    .required(),
  // El correo se pide siempre, también cuando las entradas van por WhatsApp
  // (queda como canal de respaldo y para el comprobante). Solo se confirma dos
  // veces el dato del canal elegido.
  email: yup
    .string()
    .required('Debes ingresar un correo')
    .matches(emailRegex, 'Este correo no está bien')
    .test('no-spaces', 'No se permiten espacios', noSpaces),
  emailConfirm: yup.string().when('contactMethod', {
    is: 'email',
    then: (schema) => schema
      .required('Debes ingresar un correo')
      .oneOf([yup.ref('email')], 'Los correos no coinciden')
      .test('no-spaces', 'No se permiten espacios', noSpaces),
    otherwise: (schema) => schema.optional(),
  }),
  phone: yup.string().when('contactMethod', {
    is: 'phone',
    then: (schema) => schema
      .required('Debes ingresar un celular')
      .test('is-valid-phone', 'Ingresá un celular válido', (value) => {
        if (!value) {
          return false;
        }
        const pn = parsePhoneNumberFromString(value);
        return !!pn && pn.isValid();
      }),
    otherwise: (schema) => schema.optional(),
  }),
  phoneConfirm: yup.string().when('contactMethod', {
    is: 'phone',
    then: (schema) => schema
      .required('Debes ingresar un celular')
      .oneOf([yup.ref('phone')], 'Los teléfonos no coinciden'),
    otherwise: (schema) => schema.optional(),
  }),
});
